import {
    WidgetStrategyWithConfig,
    WidgetStrategyWithStreams,
} from 'widgets/WidgetRegistry';
import IntraDayProfile from './IntraDayProfile';
import { IntraDayProfileConfiguration } from './store/configuration/IntraDayProfileConfiguration';
import { WidgetCategory } from 'widgets/WidgetCategory';
import { intradayProfileDescription } from './description/intradayProfileDescription';
import { streamConfig } from 'widgets/intraDayProfile/store/data/stream-config';
import { PortfolioSelectionRequirements } from 'widgets/PortfolioSelectionRequirements';
import { buildIntraDayProfileConfigSlice } from 'widgets/intraDayProfile/store/configuration/configSlice';
import { AppMode } from 'app/store/general/AppMode';

const { initialConfigState } = buildIntraDayProfileConfigSlice();

export const intraDayProfileWidgetStrategy: WidgetStrategyWithConfig<IntraDayProfileConfiguration> &
    WidgetStrategyWithStreams = {
    title: 'Intraday Profile',
    supportedHosts: ['layout'],
    reactComponentType: IntraDayProfile,
    initialConfigState,
    categories: [
        {
            appModes: [AppMode.STANDALONE],
            categories: [WidgetCategory.MULTIPLE_STOCK],
        },
        {
            appModes: [AppMode.EMBEDDED_DASHBOARD],
            categories: [WidgetCategory.PORTFOLIO],
        },
    ],
    description: intradayProfileDescription,
    streamConfigs: [streamConfig],
    portfolioSelectionRequirements:
        PortfolioSelectionRequirements.AtLeastOneSymbolQuantity,
};
